class RecaptchaForm
{
    constructor(form){
        this.form = form;
        this.submitButton =  form.querySelector('[type="submit"]');
        this.submitButton.addEventListener('click', (e) => { this.clickHandler(e) });
        this.alertContainer =  this.form.querySelector('.recaptcha-alert');
    }

    clickHandler(e)
    {
        const grcaptchaInput = this.form.querySelector("[name='g-recaptcha-response']")
        if(!grcaptchaInput || !grcaptchaInput.value){
            e.preventDefault();
            e.stopPropagation();
            grecaptcha.ready(() =>  {
                try{
                    grecaptcha.execute( this.form.dataset.sitekey, {action: 'submit'}).then((token) => {
                        console.log(token);
                        if(!grcaptchaInput)
                        {
                            let input = document.createElement("input");
                            input.type = "hidden";
                            input.name = "g-recaptcha-response";
                            input.value = token;
                            this.form.appendChild(input);
                        }
                        else{
                            grcaptchaInput.value = token;
                        }
                        if(token != null)
                        {
                            this.submitButton.click();
                        }   
                        else{
                            this.showError();
                        }                                          
                    }).catch((error) => { 
                        this.showError();
                        //Can implement Sentry logging
                    });
                }
                catch(error){
                    this.showError();
                     //Can implement Sentry logging
                }
              
            });
        }
    }

    showError()
    {
        if(!this.alertContainer)
        {
            alert("Sorry, we have detected an issue submitting the form - the system we use to determine and exclude automated submission of data (from bots) is malfunctioning - please try again  or contact us by email");
        }
        else{
            this.alertContainer.innerHTML = "Sorry, we have detected an issue submitting the form - the system we use to determine and exclude automated submission of data (from bots) is malfunctioning - please try again  or contact us by email";
            this.alertContainer.scrollIntoView({ behavior: "smooth"});
        }      
    }
}

const RecaptchaForms = document.querySelectorAll(".recaptcha-form");

RecaptchaForms.forEach( (form) => {
    new RecaptchaForm(form);
});

export default RecaptchaForm;
